// *******************************************************************************
// 1.0 - Form Validation
// *******************************************************************************

document.addEventListener('DOMContentLoaded', () => {
  const warrantyForm = document.querySelector('.warranty');
  const warrantyFormEle = document.getElementById('warranty-form');

  if (warrantyFormEle) {
    const warrantySubmitBtn = warrantyFormEle.querySelector('.warranty__submit-btn');

    const axiosWarrantyForm = async (formData, products) => {
      const data = {
        id: localData.id,
        action: warrantyForm.querySelector('[name="warranty-form-action"]').value,
        nonce: warrantyForm.querySelector('[name="warranty-form-nonce"]').value,
        inputs: JSON.stringify(formData),
        products: JSON.stringify(products),
      };

      try {
        const response = await axios.post(localData.siteURL, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        warrantyForm.classList.add('show-thankyou');
      } catch (err) {
        console.error(err);
      }
      warrantySubmitBtn.disabled = false;
    };

    const fv = FormValidation.formValidation(warrantyFormEle, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {},
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.mod-input, .checkbox, .dropdown'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        excluded: new FormValidation.plugins.Excluded(),
        trigger: new FormValidation.plugins.Trigger(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
    .on('core.element.validated', (e) => {
      // e.element presents the field element
      // e.valid indicates the field is valid or not

      // Get the field value
      const value = fv.getElementValue(e.field, e.element);
      const container = FormValidation.utils.closest(e.element, '.mod-input, .checkbox, .dropdown');
      FormValidation.utils.classSet(container, { 'is-validation-failed': !e.valid && value === '' });
    })
    .on('core.form.valid', (e) => {
      const formData = {};
      const products = [];
      warrantyForm.querySelectorAll('input').forEach((input) => {
        if (input.type === 'checkbox') {
          formData[input.name] = input.checked;
        } else {
          formData[input.name] = input.value.trim();
        }
      });

      warrantyForm.querySelectorAll('.warranty-form__extra:not(.template)').forEach((input) => {
        products.push({
          name: input.querySelector('.dropdown-product .dropdown__placeholder-text').innerText.trim(),
          width: input.querySelector('.dropdown-width .dropdown__placeholder-text').innerText.trim(),
          length: input.querySelector('.dropdown-length .dropdown__placeholder-text').innerText.trim(),
          quantity: input.querySelector('input[name^="quantity"]').value.trim(),
          custom: input.querySelector('input[name^="custom-made-"]').value.trim(),
        });
      });
      warrantySubmitBtn.disabled = true;
      axiosWarrantyForm(formData, products);
    });

    // Add new fields from template and give them unique ids and names
    const template = warrantyFormEle.querySelector('.template');
    let rowIndex = 0;

    warrantyFormEle.querySelector('.warranty-form__add-more-btn').addEventListener('click', () => {
      rowIndex += 1;

      const clone = template.cloneNode(true);
      clone.style.display = 'block';
      clone.setAttribute('data-row-index', rowIndex);
      template.before(clone);
      clone.classList.remove('template');

      ['name', 'id', 'for'].forEach((attr) => {
        clone.querySelectorAll(`[${attr}]`).forEach((itemName) => {
          const attribute = itemName.getAttribute(attr);
          itemName.setAttribute(attr, `${attribute}-${rowIndex}`);
          if (attr === 'name') {
            fv.addField(`${attribute}-${rowIndex}`);
          }
        });
      });
    });

    // Remove new fields
    attachEvent('.delete-extra', 'click', (deleteBtn) => {
      const parent = deleteBtn.target.closest('.warranty-form__extra');
      parent.remove();
    });

    // Checkboxes
    const checkAll = warrantyFormEle.querySelector('.warranty-check-all input[type="checkbox"]');
    const checkboxes = warrantyFormEle.querySelectorAll('.warranty-form__checkboxes input[type="checkbox"]');

    if (checkAll) {
      checkAll.addEventListener('change', () => {
        checkboxes.forEach((checkbox) => {checkbox.checked = checkAll.checked})
      });

      const updateCheckAll = () => {
        checkAll.checked = [...checkboxes].every(checkbox => checkbox.checked)
      };

      checkboxes.forEach(checkbox => checkbox.addEventListener('change', updateCheckAll));
      updateCheckAll();
    }
  }
});
